import { createActionGroup, props } from "@ngrx/store";

import { MethodType } from "./method-type.state";

export const methodTypeActions = createActionGroup({
  source: "Method Type",
  events: {
    "Find For Sample": props<{ sampleId: string }>(),
    "Find For Sample Success": props<{ methodType: MethodType }>(),
    "Find For Sample Failure": props<{ error: string }>(),
  },
});